import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {AccountOpenings} from '~local/app/types/AccountOpenings';
import {Observable} from 'rxjs';
import {DataSourceResponse, DataSourceService} from './DataSourceService';

@Injectable()
export class AccountOpeningsService extends DataSourceService<AccountOpenings> {
    constructor(private readonly http: HttpClient, private readonly domSanitizer: DomSanitizer) {
        super();
    }

    public loadData(
        filter: string = '',
        orderBy: string = '',
        orderDirection: string = 'ASC',
        pageNumber: number = 0,
        pageSize: number = 10,
        globalFilter: string | null = null
    ): Observable<DataSourceResponse<AccountOpenings>> {
        return this.http.get<DataSourceResponse<AccountOpenings>>('/admin/account-openings/list/' + (globalFilter || ''), {
            params: new HttpParams()
                .set('filter', filter)
                .set('orderBy', orderBy)
                .set('sort', orderDirection.toUpperCase())
                .set('skip', pageNumber.toString())
                .set('take', pageSize.toString())
        });
    }

    public externalProviders$(): Observable<Array<{ label: string, value: string }>> {
        return this.http.get<Array<{ label: string, value: string }>>('/admin/account-openings/external-providers');
    }

    public approve(accountManualApprovalId: number, externalFinancialProvider: string): Observable<any> {
        console.log('[AccountOpeningsService]:approve', accountManualApprovalId);
        return this.http.post('/admin/account-openings/approve', { accountManualApprovalId, externalFinancialProvider });
    }
}
